<!-- Floating Icon -->
<div class="chatbot-icon" (click)="toggleChatbot()">
  <i class="fa fa-comments"></i>
</div>

<!-- Chatbot Window -->
<div class="chatbot-window" [ngClass]="isLoggedIn ? 'chatbot-login' : 'chatbot-guest'" *ngIf="showChatbot">
  <div class="chatbot-header">
    <span>AI Helpdesk</span>

    <button type="button" class="close-btn" (click)="toggleChatbot()">
      ×
    </button>
  </div>

  <div class="chatbot-content">
    <iframe
      [src]="chatbotUrl"
      id="chatbotFrame"
      (load)="onIframeLoad()"
      [style.transform]="'scale(' + iframeScale + ')'"
      [style.width]="(100 / iframeScale) + '%'"
      [style.height]="(100 / iframeScale) + '%'"
      style="transform-origin: top left; border: 0;font-size: smaller;"
      frameborder="0"
    ></iframe>
  </div>
</div>
